import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, useGrid, usePopup, useStore, useToast, useModal } from "@/comn/hooks";
import { BASE, APIS, SG_CO_USR_LIST, SF_CO_USR_SRCH } from "./services/ComnCdService";
import { Link } from "react-router-dom";

export const CoUsrList = (props: any) => {
    const pgeUid = "coUsrLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const params = props.params;

    const form = {
        coUsrSrch: useForm({
            defaultSchema: SF_CO_USR_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        coUsrLst: useGrid({
            defaultSchema: SG_CO_USR_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getCoUsrLst: useFetch({
            api: (page = grid.coUsrLst.page) => {
                return APIS.getCoUsrtLst(form.coUsrSrch.getValues(), page, grid.coUsrLst.size);
            },
            enabled: comnUtils.isEmpty(form.coUsrSrch.errors) && form.coUsrSrch.isSubmitted,
            key: [grid.coUsrLst.page, grid.coUsrLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.coUsrSrch.getValues(),
                    page: grid.coUsrLst.page,
                    size: grid.coUsrLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.coUsrSrch.handleSubmit(
                () => {
                    grid.coUsrLst.setPage(0);
                    fetch.getCoUsrLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.coUsrLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.com.00086" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_CoUsrLst: {
            cell: {
                usrId: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: value, label: rowValues.usrNm });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.coUsrLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page title={t("T_CO_USR_LST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.coUsrSrch.schema.usrId}></Group.Control>
                                <Group.Control {...form.coUsrSrch.schema.usrNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.coUsrSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    {/* * */}
                    {params?.multiple === true && (
                        <Layout>
                            <Layout.Right>
                                <Button
                                    role="apply"
                                    onClick={() => {
                                        handler.click_Btn_Apply();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    )}
                    <Grid
                        {...grid.coUsrLst.grid}
                        data={fetch.getCoUsrLst.data?.coUsrList}
                        render={render.grid_CoUsrLst}
                    />
                </Group.Body>
            </Group>
        </Page>
    );
};
